import React, { useState } from "react";
import ReusableSidebar from "../../components/sidebar/reusable-sidebar";
import { useUser } from "../../services/contexts/user-context";
import { MainContent } from "../../components/sidebar/sidebar.styles";
import Messages from "./messages";
import Loading from "../../components/loading";

const DefaultMessages = () => {
  const { user, isLoading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        selectedPage="messages"
        user={user}
        loading={isLoading}
      />
      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? <Loading /> : <Messages />}
      </MainContent>
    </>
  );
};

export default DefaultMessages;
